type AssistantIconProps = {
    size?: number;
    color?: string;
};

export function AssistantIcon({ size = 18, color = 'currentColor' }: AssistantIconProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            aria-hidden
            fill={color}
            style={{ display: 'block', flexShrink: 0 }}
        >
            <path d="M12 2l1.09 6.26L19 9.27l-5.91 1.01L12 16.54l-1.09-6.26L5 9.27l5.91-1.01L12 2zm7 13l.75 2.25L22.5 18l-2.25.75L19 21l-.75-2.25L16.5 18l2.25-.75L19 15zm-14 0l.5 1.5L7.5 17l-1.5.5L5 19l-.5-1.5L3 17l1.5-.5L5 15z" />
        </svg>
    );
}
